import { DateFormats, formatDate, openInNewTab } from '@strata/helper-functions';
import { ActionButtonText } from '@strata/react-buttons';
import { FormSection } from '@strata/react-form-section';
import { type ColumnDef, Grid, SecondaryData } from '@strata/react-grid';

import { getIntakeCaseFile } from 'api/intakeCaseAPI';
import { handleError } from 'services/Error';
import { type IntakeCase } from 'store/api/intakeCaseApi';

interface DocumentsProps {
    intakeCaseDetails: IntakeCase | undefined;
    isLoading: boolean;
}
const columns = ({
    intakeCaseDetails,
}: Pick<DocumentsProps, 'intakeCaseDetails'>): ColumnDef<IntakeCase['clinicalFiles'][0]>[] => [
    {
        accessorKey: 'name',
        header: 'Document',
        cell: ({ getValue, row }) => (
            <ActionButtonText
                label={<span style={{ textTransform: 'none' }}>{getValue()}</span>}
                onClick={() => {
                    (async () => {
                        try {
                            if (intakeCaseDetails?.intakeCaseId) {
                                openInNewTab(
                                    URL.createObjectURL(
                                        await getIntakeCaseFile({
                                            intakeCaseId: intakeCaseDetails.intakeCaseId,
                                            intakeCaseClinicalFileId:
                                                row.original.intakeCaseClinicalFileId,
                                            filename: getValue(),
                                        }),
                                    ),
                                );
                            }
                        } catch (err) {
                            handleError('Error downloading file.', err as Error);
                        }
                    })();
                }}
            />
        ),
    },
    {
        accessorKey: 'dateAdded',
        header: 'Date Added',
        cell: ({ getValue }) => (
            <SecondaryData data={formatDate(getValue(), DateFormats.DATE_TIME)} />
        ),
    },
];

export const Documents = ({ intakeCaseDetails, isLoading }: DocumentsProps) => (
    <FormSection
        sectionTitle="Documents"
        isLoading={isLoading}
        content={
            <Grid
                data={intakeCaseDetails?.clinicalFiles}
                noResults={
                    <div className="sds_intake-case-details__section--no-results">
                        No documents.
                    </div>
                }
                columns={columns({ intakeCaseDetails })}
            />
        }
    />
);
